import {createAction} from '@reduxjs/toolkit'

export const updateActivity = createAction('activity/save', (data) => ({
  payload: data
}))
